webpackJsonp([19682688780327],{

/***/ 1198:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0011_undo.jpg","type":"Spell","subtype":"Bounce","cost":3,"ATK":null,"HP":null,"rules_text_1":"Return a tech 0, I, or II unit to its owner's hand.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Undo","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Purple","spec":"Past","bottom":"Magic","rulings":[{"ruling":"This doesn't cause the unit to \"die\", so the opponent won't draw a card if it was in the technician slot.","date":"2016-03-11T08:00:00.000Z","author":"Sirlin"}],"keywords":[],"slug":"undo"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"undo","keywords":[],"imageRegex":"/undo.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-undo-8ce7cc05e98f116c2806.js